var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useState } from 'react';

import { connect } from 'react-redux';

import { TableRow } from "../Library/components/TableRow";








const mapStateToProps = (state, props) => ({
  documents: state[props.storeKey].documents,
  selectionLength: state[props.storeKey].ui.get('selectedDocuments').size
});

const connector = connect(mapStateToProps);


const TableRowsComponent = ({
  documents,
  columns,
  clickOnDocument,
  storeKey,
  selectionLength
}) => {
  const [multipleSelection, setMultipleSelection] = useState(selectionLength > 1);
  return (/*#__PURE__*/
    React.createElement(React.Fragment, null,
    documents.
    get('rows').
    map((entity) => /*#__PURE__*/
    _jsx(TableRow, {
      entity: entity,
      columns: columns,
      clickOnDocument: clickOnDocument,
      storeKey: storeKey,

      setMultipleSelection: setMultipleSelection,
      multipleSelection: multipleSelection }, entity.get('_id')
    )
    ).
    toArray()
    ));

};

export const TableRows = connect(mapStateToProps)(TableRowsComponent);